module.exports = __webpack_public_path__ + "static/media/3.cca44c4d.jpg";